"use client";
import { useTranslation } from "@/hooks/localization/useTranslations";
import React from "react";
import { useProductBox } from "../context/ProductBoxContext";

const StockAlertMessage: React.FC<{ minStockQuantity: number }> = ({
  minStockQuantity,
}) => {
  const { outOfStock } = useProductBox();
  const t = useTranslation();
  return (
    !outOfStock && (
      <p className="stock-alert-message m-0">{`${t.only} ${minStockQuantity} ${t.pieces_available}`}</p>
    )
  );
};

export default StockAlertMessage;
